import { AxiosResponse } from 'axios';
import SuccessRs from '@domain/rs/common/SuccessRs';
import { axios } from '@repository/RequestClient';
import AiTrialResultRs from '@domain/rs/ai/AiTrialResultRs';
import ApplicationPeriodStatusRs from '@domain/rs/application/ApplicationPeriodStatusRs';
import submitYnRs from '@domain/rs/application/SubmitYnRs';

export default interface AiRepo {
  trialResult(): Promise<AxiosResponse<AiTrialResultRs>>;

  fetchCheckApplicationPeriod(): Promise<AxiosResponse<ApplicationPeriodStatusRs>>;

  fetchCheckIsSubmit(): Promise<AxiosResponse<submitYnRs>>;

  fetchSubmitCode(code: string): Promise<AxiosResponse<SuccessRs>>;
}

export class RemoteAiRepo implements AiRepo {
  trialResult() {
    return axios.get<AiTrialResultRs>('/ai/trial/result');
  }

  fetchCheckApplicationPeriod() {
    return axios.get<ApplicationPeriodStatusRs>('/ai/application/check/period');
  }

  fetchCheckIsSubmit() {
    return axios.get<submitYnRs>('/ai/application/check/submit');
  }

  fetchSubmitCode(code: string): Promise<AxiosResponse<SuccessRs>> {
    return axios.post<SuccessRs>('/ai/application/create', { code });
  }
}
